// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__dbOdP","footer":"ChangeClinic_footer__1QF2T"};